import ApiClient from './ApiClient';

// BonBoZ: CẤU HÌNH THEO TRANG — màu nhận diện, bộ thẻ, mẫu trả lời của từng
// hộp thư. Trước đây nằm ở service CRM (Python, cổng 8088) và phải tự đính
// token agent vào header; giờ là endpoint Chatwoot nên `ApiClient` lo xác thực,
// baseURL và account_id — không còn `fetch` tay, không còn CORS.
//
//   GET   .../bonboz/page_configs
//         -> { "<inbox_id>": { labels, color, canned_response_ids }, ... }
//         MỌI inbox trong một lượt, agent nào cũng đọc được.
//   PATCH .../bonboz/page_configs/:inbox_id
//         GỘP: chỉ gửi khoá của màn hình mình, khoá không gửi giữ nguyên, gửi
//         null là xoá. Nhờ vậy hai màn hình sửa hai khoá khác nhau trên cùng
//         một trang không đạp lên nhau. Chỉ administrator, agent nhận 403.
//
// `get()` và `update(id, data)` kế thừa từ ApiClient đã đúng hai lời gọi trên,
// nên lớp này không thêm phương thức nào.
class PageConfigsAPI extends ApiClient {
  constructor() {
    super('bonboz/page_configs', { accountScoped: true });
  }
}

/**
 * Câu lỗi để hiện cho người dùng. Message của axios luôn là "Request failed
 * with status code 403" — vô nghĩa với người trực page; Rails trả lý do thật
 * trong `error`, ưu tiên cái đó.
 */
export const loiApi = e => e?.response?.data?.error || e?.message || '';

export default new PageConfigsAPI();
